<template>
    <div class="scheduled-clients-button" v-if="!showPreditivaCampaign && !showImplantacaoCampaign && !showBillingCampaign">
        <button class="btn btn-info scheduled-btn" @click="showScheduledClients">
            <i class="fa-solid fa-calendar-day" style="font-size: 15px;"></i>
            Lembrete Preditivo
            <!-- Badge de notificação -->
            <span class="notification-badge">
                {{ clients.length }}
            </span>
        </button>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { mapGetters } from "vuex";

const parsedTelefone = process.env.MIX_TELEFONE === "true";
const connection = parsedTelefone ? io.connect(`${location.protocol}//${location.hostname}:3001/`) : { on: function () { }, emit: function () { } };

export default {
    name: "ScheduledClients",
    data() {
        return {
            clients: [],
            notifiedSwal: false,
        };
    },
    computed: {
        ...mapGetters({
            showPreditivaCampaign: "getShowPreditivaCampaign",
            showImplantacaoCampaign: "getShowImplantacaoCampaign",
            showBillingCampaign: "getShowBillingCampaign",
        }),
    },
    methods: {
        async checkClients() {
            try {
                const { data } = await axios.get("/getScheduledCalls");

                const clients = Array.isArray(data) ? data : (data ? [data] : []);

                this.clients = clients.filter(client =>
                    client.scheduled_to === null || Number(client.scheduled_to) === Number(user.getId())
                );

            } catch (error) {
                this.clients = [];
            }
        },

        async showScheduledClients() {
            await this.checkClients();
            const check = this.clients;

            if (check) {
                check.sort((a, b) => moment(a.schedule_date).unix() - moment(b.schedule_date).unix());
            }

            const upcomingSchedules = (check || [])
                .filter((client) => {
                    const scheduleTime = moment(client.schedule_date);
                    const now = moment();
                    // const diffInMinutes = scheduleTime.diff(now, "minutes");
                    return (
                        // diffInMinutes <= 60 &&
                        // diffInMinutes >= 0 && (
                        client.scheduled_to === null || Number(client.scheduled_to) === Number(user.getId())
                    );
                })
                .map((client) => ({
                    id: client.id,
                    clientName: client.client_name,
                    phone: client.client_phone,
                    time: moment(client.schedule_date).format("DD/MM/YYYY HH:mm"),
                    consultant: client.scheduled_name?.trim() || "Livre",
                }));

            let scheduleListHTML = `<div style="display:flex; flex-direction:column; gap:10px; padding:8px;">`;

            upcomingSchedules.forEach((schedule) => {
                scheduleListHTML += `
<div style="
    display:flex;
    justify-content:space-between;
    align-items:center;
    background:#fff;
    padding:12px 14px;
    border-radius:10px;
    border:1px solid #e0e0e0;
    box-shadow:0 2px 4px rgba(0,0,0,0.05);
    transition: all 0.2s ease;
" 
onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 10px rgba(0,0,0,0.12)';" 
onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.05)';">

    <!-- Dados do cliente -->
    <div style="display:flex; flex-direction:column; gap:4px;">
        <strong style="color:#1a6fa5; font-size:15px;">${schedule.clientName}</strong>
        <span style="color:#555; font-size:13px; display:flex; align-items:center; gap:5px;">
            <i class="fas fa-user" style="color:#16a085;"></i> ${schedule.consultant}
        </span>
        <span style="color:#555; font-size:13px; display:flex; align-items:center; gap:5px;">
            <i class="fas fa-phone-alt" style="color:#2980b9;"></i> ${schedule.phone}
        </span>
    </div>

    <!-- Ações -->
    <div style="display:flex; flex-direction:column; align-items:flex-end; gap:6px;">
        <span style="
            background:#16a085;
            color:white;
            font-weight:bold;
            font-size:13px;
            padding:3px 10px;
            border-radius:12px;
            display:flex;
            align-items:center;
            gap:4px;
        ">
            <i class="fas fa-clock"></i> ${schedule.time}
        </span>

        <button 
            data-phone="${schedule.phone}"
            class="btn-call-schedule"
            style="
                background:#27ae60;
                color:white;
                border:none;
                padding:6px 14px;
                border-radius:10px !important;
                cursor:pointer;
                font-size:11px;
                font-weight:600;
                display:flex;
                align-items:center;
                gap:6px;
                transition: background 0.2s;
            "
            onmouseover="this.style.background='#219150';"
            onmouseout="this.style.background='#27ae60';"
        >
            <i class="fas fa-phone-alt"></i> Ligar
        </button>
    </div>
</div>
`;
            });

            scheduleListHTML += "</div>";

            Swal.fire({
                width: "620px",
                html: `
    <div style="font-family:'Arial', sans-serif; text-align:center;">
        <div style="
            display:flex;
            justify-content:center;
            align-items:center;
            background-color:${upcomingSchedules.length > 0 ? '#16a085' : '#e74c3c'};
            border-radius:50%;
            width:60px;
            height:60px;
            margin:0 auto;
            color:#fff;
        ">
            <i class="fas ${upcomingSchedules.length > 0 ? 'fa-calendar-check' : 'fa-calendar-xmark'}" style="font-size:28px;"></i>
        </div>

        <h3 style="color:#2c3e50; margin:15px 0 12px; font-size:17px; font-weight:bold;">
            ${upcomingSchedules.length > 0 ? "Clientes Agendados!" : "Sem Clientes Agendados"}
        </h3>

        <div style="max-height:320px; overflow-y:auto; padding-right:6px; text-align:left;">
            ${upcomingSchedules.length > 0 ? scheduleListHTML : "<p style='color:#555; font-size:14px; text-align:center;'>Sem clientes agendados</p>"}
        </div>

        ${upcomingSchedules.length > 0 ? `<p style="color:#555; font-size:14px; margin-top:12px; text-align:center;">
            Existem <strong style="color:#e74c3c;">${upcomingSchedules.length}</strong> clientes agendados
        </p>` : ""}
    </div>
    `,
                showCloseButton: true,
                showConfirmButton: false,
                background: "#ecf0f1",
                customClass: { popup: "animated fadeInDown" },

                // usa diretamente o parâmetro `popup` fornecido pelo SweetAlert2
                onOpen: (popup) => {
                    // `popup` é o elemento DOM do modal — bind nele para delegação de clique
                    popup.addEventListener("click", (e) => {
                        const btn = e.target.closest(".btn-call-schedule");
                        if (!btn) return;
                        const phone = btn.getAttribute("data-phone") || btn.dataset.phone;
                        if (!phone) return;
                        
                        const client = this.clients.find(c => c.client_phone === phone);
                        if (client) {
                            // Salva no sessionStorage para usar depois no Hangup
                            sessionStorage.setItem("campaignClient", JSON.stringify(client));
                        }

                        this.call_client(phone); // chama seu método Vue com o client_phone
                        // Se quiser que o modal feche quando iniciar a ligação, descomente:
                        Swal.close();
                    });
                },
            });
        },

        call_client(phone) {
            if (phone) {
                const formattedPhone = this.formatPhoneToCall(phone);
                connection.emit("OriginateTabDial", {
                    calltype: "outgoing",
                    extension: user.getExtension(),
                    phone: formattedPhone,
                });
            }
        },

        formatPhoneToCall(phone) {
            let newPhone = phone.replace(/\D/g, "");

            if (newPhone.slice(0, 1) == "0") {
                newPhone = newPhone.slice(1);
            }
            if (newPhone.slice(0, 2) == "55") {
                newPhone = `0${newPhone.slice(2)}`;
            }


            return newPhone;

        },
    },

    mounted() {
        this.checkClients();
    },
};
</script>

<style scoped>
.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scheduled-clients-button {
    position: absolute;
    right: 0;
    top: 0;
    margin: 20px;
}

.scheduled-btn {
    background-color: #007bff;
    color: white;
    border-radius: 20px !important;
    margin: 0;
    padding: 10px 30px;
    font-weight: bold;
    font-size: 14px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s, transform 0.2s;
    border: none;
}

.scheduled-btn:hover {
    background-color: #0056b3;
    transform: scale(1.05);
}
</style>